import React, { useEffect, useState } from 'react';

import { GetIncludedCoveragesHandler, PlanCardContent } from '@components/card/PlanCard';
import PlanCards from '@components/card/PlanCards';
import { findMatchRecordByName, mapWYSIWYGBulletToArray } from '@pages/misc/PlansAndPrices';
import { PlanPriceSummary } from '@components/card/CardPlanPriceSummary';
import {
  EmptyResultsContainer,
  PlanCardMetaFieldRecordsByLookup,
  PlanCardMetaFields,
  PlanSelectionHandler,
} from '@templates/misc/PlansAndPricesTemplate';

interface PlanCardsOldProps {
  plans: PlanPriceSummary[];
  selectedPlan?: {
    pvid: string;
  };
  onPlanSelection: PlanSelectionHandler;
  meta?: {
    plans: {
      lookup_text: string;
      plan_subtext: string;
      coverage_items: string;
    }[];
  };
  loading: boolean;
  loadingPageMeta?: boolean;
  getIncludedCoverages?: GetIncludedCoveragesHandler;
  init?: boolean;
}

const PlanCardsOld: React.FC<PlanCardsOldProps> = (props) => {
  const [planCardMetaFields, setPlanCardMetaFields] = useState<PlanCardMetaFieldRecordsByLookup>(
    {},
  );

  const getPlanSubtext = (planName: string): string => {
    return (
      findMatchRecordByName<PlanCardMetaFieldRecordsByLookup, PlanCardMetaFields>(
        planCardMetaFields,
        planName,
      )?.planSubtext || ''
    );
  };

  const getCoverageItems = (planName: string): string[] => {
    return (
      findMatchRecordByName<PlanCardMetaFieldRecordsByLookup, PlanCardMetaFields>(
        planCardMetaFields,
        planName,
      )?.coverageItems || ['<i>Failed to load</i>']
    );
  };

  const getPlans = (): PlanCardContent[] => {
    return props.plans.map((plan) => {
      return {
        pvid: plan.pvid,
        heading: plan.heading,
        subtext: getPlanSubtext(plan.heading),
        price: plan.price,
        coverages: getCoverageItems(plan.heading) as string[],
        bestCoverage: false,
        selected: props.selectedPlan?.pvid === plan.pvid,
        zestyBased: true,
      };
    });
  };

  const handleSelect = (pvid: string) => {
    const planContent = props.plans.find((plan) => plan.pvid === pvid);
    props.onPlanSelection(planContent);
  }; /** set the meta data for plan text and items */

  useEffect(() => {
    if (props.meta) {
      const metaFields: PlanCardMetaFieldRecordsByLookup = {};
      props.meta.plans.forEach((plan) => {
        metaFields[plan.lookup_text] = {
          planSubtext: plan.plan_subtext,
          coverageItems: mapWYSIWYGBulletToArray(plan.coverage_items),
        };
      });
      setPlanCardMetaFields(metaFields);
    }
  }, [props.meta]);

  return (
    <>
      {props.loading && (
        <PlanCards plans={[]} onSelectCallback={null} loading={true} loadingCount={3} />
      )}
      {!props.loading && props.plans.length > 0 && (
        <div id="result-container--plans">
          <div className="w-full flex space-x-2">
            {!props.loading && props.plans.length === 0 && !props.loadingPageMeta && (
              <EmptyResultsContainer init={props.init} />
            )}
            {props.loading && (
              <PlanCards plans={[]} onSelectCallback={null} loading={true} loadingCount={3} />
            )}
            {!props.loading && props.plans.length > 0 && (
              <PlanCards
                onSelectCallback={handleSelect}
                plans={getPlans()}
                getIncludedCoverages={props.getIncludedCoverages}
                zestyBased={true}
                selectedPlanID={props.selectedPlan?.pvid}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default PlanCardsOld;
